import { useMutation } from "@tanstack/react-query";
import { presignOwnerIdDownload } from "../../api/owner-ids";
import { downloadFile, showToast } from "@/modules/common/utils";
import { TOAST_IDS, ToastType } from "@/modules/common/types";

const useDownloadOwnerId = () => {
  const mutation = useMutation({
    mutationFn: (ownerIdUid: string) => presignOwnerIdDownload(ownerIdUid),
    onSuccess: (data) => {
      const images = data.data.images ?? [];
      images.forEach((image) => {
        if (image.fileUrl) {
          downloadFile(image.fileUrl);
        }
      });
    },
    onError: () => {
      showToast({
        type: ToastType.ERROR,
        message: "Failed to download owner ID",
        toastId: TOAST_IDS.DOWNLOAD_OWNER_ID_ERROR,
        options: {
          position: "bottom-left",
          autoClose: 3000,
        },
      });
    },
  });

  return {
    download: mutation.mutate,
    isDownloading: mutation.isPending,
  };
};

export default useDownloadOwnerId;
